import { render, staticRenderFns } from "./elasticDistinct.vue?vue&type=template&id=b8b2e516"
import script from "./elasticDistinct.vue?vue&type=script&lang=js"
export * from "./elasticDistinct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports